import { Component, OnInit, HostListener,ViewChild,ElementRef } from '@angular/core';
import { StateService } from "../../services/state.service";
import { googleAnalytics } from "../../services/googleAnalytics.service";
import { UserService } from "../../services/user.service";
import { ArticlesWebSocketsService } from "../../webSockets/articles-web-sockets.service";
import { UserApiService } from "../../api/user-api.service";
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder,Validators } from '@angular/forms'
import {Router} from '@angular/router'
import { AutenticateApiService } from '../../api/autenticate-api.service';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-aplication',
    templateUrl: './aplication.component.html',
    styleUrls: ['./aplication.component.css']
})
export class AplicationComponent implements OnInit {
    @ViewChild('password', { static:false }) password:ElementRef
    @ViewChild('password2',{ static:false }) password2:ElementRef

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
      this.userApi.endUserSesion().subscribe()
    }

	tipo
	tipoestado=true
	tipo_reset
	tipoestado_reset=true
    inputValue:FormGroup;
    loading:boolean= false
    regex=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
    constructor(
        public state: StateService,
        public googleAnalytics: googleAnalytics,
        public userService: UserService,
        public userApi: UserApiService,
        public articlesWebSockets: ArticlesWebSocketsService,
        private fb:FormBuilder,
        private router:Router,
        private auth:AutenticateApiService
    ) {

      this.inputValue = this.fb.group({
            password:["",[Validators.required,Validators.minLength(6), Validators.pattern(this.regex)]],
            password2:["",[Validators.required,Validators.minLength(6), Validators.pattern(this.regex)]]
      })

    }

    ngOnInit() {
        this.googleAnalytics.login(this.state.getValueOf('user').sub)
        this.articlesWebSockets.connect()
        this.tipo='password'
		this.tipo_reset='password'
        this.validarprimerpass(this.state.getValueOf('user').sub)
        this.refeshToken()
    }

    validateInput(field){
        return ( (!this.inputValue.get(field).valid && this.inputValue.get(field).touched ) ? 'is-invalid' : this.inputValue.get(field).touched ? 'is-valid' : '' )
    }

    async validarprimerpass(cedula){

        let datos={
            cedula:cedula
        }

        this.userApi.validarUser(datos).subscribe((data:any)=>{

            if(data.length===1){

                this.userApi.validarprimerpass(datos).subscribe(data=>{
            
                    if (data[0].primer_ingreso == 1 && data[0].metodo_ingreso == 0) {
                        ($('#exampleModal5') as any).modal('show') 
                    }
                    
                })

            }

        })
        

    }

    cambiarpassword(){
     
   
    this.loading = true
         const { password, password2 } = this.inputValue.value
         if(password !== password2){
              Swal.fire({
                 icon:'error',
                 title:'Opss!',
                 text:'las contraseña no coinciden'
             })
             this.loading= false
             return
         }

         let data = {
            nuevo_password_reset:password,
            cedula:this.state.getValueOf('user').sub
        }

        this.userApi.nuevoPassword(data).subscribe(()=>{
            Swal.fire({
                icon:'success',
                title:  'Password Cambiado',
                showConfirmButton: false,
                timer: 1500
              }),
              this.loading = false,
              this.router.navigate(['/']),
              ($('#exampleModal5') as any).modal('hide') 
        })
    

	}

	mostrarpass(){

    this.password.nativeElement.type ==='password'
      ?  this.password.nativeElement.type ='text'
      :  this.password.nativeElement.type ='password'

	}

	mostrarpassreset(){

	 this.password2.nativeElement.type ==='password'
      ?  this.password2.nativeElement.type ='text'
      :  this.password2.nativeElement.type ='password'

	}

    refeshToken(){
       interval(200000).pipe(
          map( ()=>this.auth.refreshToken().subscribe())
       ).subscribe()
    }
 

}
